import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name : 'searchPipe',
})
export class SearchPipe implements PipeTransform {
    transform(items: any[], field: string, value: any): any[] {
        if (!items) return [];
    //console.log(items);
          console.log("asdfasdfasdfasdf",value);
        if (value) {
            return items.filter(it => it[field].includes(value));
           }
        else {
            return items;
        }
    }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/dispatcher/pipes/search.pipe.ts